<script>
import GalleryPhoto from "@/components/GalleryPhoto.vue";
import { db } from "../firebase.js";
export default {
  data() {
    return {
      items: [],
      caption: "",
    };
  },
  components: {
    GalleryPhoto,
  },
  created() {
    this.getImages()
  },
  methods: {
    addImage(url1, id1, caption1) {
      this.items.push({ imgURL: url1, id: id1, caption: caption1 });
    },
    getImages() {
      db.collection("gallery")
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            this.addImage(doc.data().url, doc.id, doc.data().caption);
          });
        })
    },
  },
};
</script>

<template>
  <div class="container-gallery">
    <div v-for="item in items" :key="item.id" :span="8">
      <div class="left">
        <GalleryPhoto :imgURL="item.imgURL" :caption="item.caption" />
      </div>
    </div>
  </div>
</template>

<style scoped>
.container-gallery {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  flex-wrap: wrap;
}

.left {
  width: 100%;
}
</style>
